import React from 'react';
import { ArrowUpRight, ArrowDownLeft, Circle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { formatDuration } from './formatDuration';

const statusLabel = (call) => {
  if (call.status === 'missed') return 'Manque';
  if (call.status === 'ended') return formatDuration(call.duration_seconds || 0);
  if (call.status === 'declined') return 'Decline';
  return call.status;
};

const iconBg = (status) => {
  if (status === 'missed') return 'bg-red-900/40';
  return status === 'ended' ? 'bg-slate-700' : 'bg-green-900/40';
};

function RecentCallRow({ call, userId }) {
  const outgoing = call.caller_id === userId;
  const missed = call.status === 'missed';
  return (
    <div data-testid={`softphone-recent-${call.id}`}
      className="flex items-center justify-between px-3 py-2.5 rounded-lg hover:bg-slate-800 transition-colors">
      <div className="flex items-center gap-3 min-w-0">
        <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${iconBg(call.status)}`}>
          {outgoing
            ? <ArrowUpRight className={`w-4 h-4 ${missed ? 'text-red-400' : 'text-slate-300'}`} />
            : <ArrowDownLeft className={`w-4 h-4 ${missed ? 'text-red-400' : 'text-green-400'}`} />}
        </div>
        <div className="min-w-0">
          <p className="text-white text-sm font-medium truncate">{outgoing ? call.callee_name : call.caller_name}</p>
          <div className="flex items-center gap-2">
            <span className={`text-xs ${missed ? 'text-red-400' : 'text-slate-500'}`}>{statusLabel(call)}</span>
            <span className="text-xs text-slate-600">
              {new Date(call.created_at).toLocaleDateString('fr-CA', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
            </span>
            {call.is_recording && <Circle className="w-2 h-2 fill-red-500 text-red-500" />}
          </div>
        </div>
      </div>
      <Badge className={`text-[10px] px-1.5 py-0 ${call.type === 'phone' ? 'bg-blue-900/50 text-blue-300' : 'bg-slate-700 text-slate-300'}`}>
        {call.type === 'phone' ? 'Tel' : 'Web'}
      </Badge>
    </div>
  );
}

export default function SoftPhoneRecentTab({ recentCalls, userId }) {
  return (
    <div className="overflow-y-auto flex-1 px-2 py-2" style={{ maxHeight: '380px' }}>
      {recentCalls.length === 0 ? (
        <p className="text-slate-500 text-sm text-center py-6">Aucun appel recent</p>
      ) : recentCalls.map(call => <RecentCallRow key={call.id} call={call} userId={userId} />)}
    </div>
  );
}
